import API from 'src/services/api';

import { JobSpec, JobSpecOptions } from './types';
import { AxiosResponse } from 'axios';
import Paginated from 'src/types/paginated';

const jobSpecApi = {
  async fetchJobSpec(params: JobSpecOptions = {}): Promise<AxiosResponse<Paginated<JobSpec>>> {
    return await API.get(`/jobsspec`, {
      params,
    });
  },
};

export default jobSpecApi;
